export default __webpack_public_path__ + "static/media/dominos-grey.e058f23b.webm";